import React, { useEffect, useState } from 'react';
import { FORM_NAME, STEP, STEPS, STREAM, AUDIO, STREAM_ERROR } from '../fields';
import { change, getFormValues, Field } from 'redux-form';
import { AudioListSelect } from '../devices';
import { Button } from 'components/button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMicrophone } from '@fortawesome/pro-regular-svg-icons';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { StreamError } from '../stream-error';
import { StreamErrorHint } from '../stream-error-hint';
import { TextBox } from '../../forms/form-fields/text-box/index';

export const ConfigurationTitle = () => {
  const { t } = useTranslation();
  return <>{t('record_screen')}</>;
};

export const ConfigurationBody = () => {
  const { t } = useTranslation();
  const { [STREAM_ERROR]: streamError } = useSelector(getFormValues(FORM_NAME));

  return (
    <>
      {streamError ? (
        <>
          <StreamErrorHint />
          <StreamError />
        </>
      ) : (
        <Field
          name="agreedToRecord"
          component={TextBox}
          props={{
            text: t('recording_gdpr_text'),
            required: true,
          }}
        />
      )}
    </>
  );
};

export const ConfigurationFooter = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [accessToAudioGranted, setAccessToAudioGranted] = useState(false);
  const { [AUDIO]: audioDeviceIds, agreedToRecord } = useSelector(getFormValues(FORM_NAME));
  const audioDeviceId = audioDeviceIds?.[0];

  useEffect(() => {
    let testStream;
    let isSubscribed = true;

    const getStream = async () => {
      // check for permission to access devices
      testStream = await window.VideoCaptureAPI.getAudioStream()?.catch((e) => {
        dispatch(
          change(FORM_NAME, STREAM_ERROR, {
            kind: e.name,
          })
        );
      });

      if (!isSubscribed) {
        return;
      }

      if (testStream) {
        dispatch(change(FORM_NAME, STREAM, testStream));
        setAccessToAudioGranted(true);
      }
    };

    if (audioDeviceId !== undefined) {
      setAccessToAudioGranted(false);
      getStream();
    }

    return () => {
      isSubscribed = false;

      if (testStream) {
        window.VideoCaptureAPI.stopMediaTracks(testStream);
      }
    };
  }, [dispatch, audioDeviceId]);

  const onStartRecording = async () => {
    try {
      const screenStream = await window.VideoCaptureAPI.getScreenStream(audioDeviceId);

      if (screenStream) {
        dispatch(change(FORM_NAME, STREAM, screenStream));
        dispatch(change(FORM_NAME, STEP, STEPS.RECORDING));
      }
    } catch (error) {
      if (error.name === window.VideoCaptureAPI.PERMISSION_DENIED) {
        return;
      }
      dispatch(
        change(FORM_NAME, STREAM_ERROR, {
          kind: error.name,
        })
      );
    }
  };

  return (
    <div className="d-flex justify-content-between">
      <div className="d-flex justify-content-between align-items-center ct-device-list">
        <FontAwesomeIcon className="mr-2" icon={faMicrophone} />
        <AudioListSelect />
      </div>

      <Button onClick={onStartRecording} disabled={!accessToAudioGranted || !agreedToRecord}>
        {t('start_screen_recording')}
      </Button>
    </div>
  );
};
